import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import AllDocumentAddPopup from "../../../../components/modelpopup/AllDocumentAddPopup";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import DeleteModal from "../../../../components/modelpopup/DeleteModal";
import DocumentListFilter from "../components/DocumentListFilter";
import { Table, Pagination } from "antd";
import { itemRender, pageSizeOptions } from "utils/table";
import { formatDateHandler2, toTitleCase } from "utils/common";

import { SkeltonLoader } from "components/skeltonLoader";
import DocumentsFilterDrawer from "components/Drawer/documentsFilterDrawer";
import { useDocument } from "../context/documentContext";
import Image from "components/Image";
import AddJobModal from "components/Administration/Jobs/ManageJobs/AddJobModal";
import { toast, Bounce } from "react-toastify";
import { deleteDocumentApi } from "api/services/documents";
import { Button } from "components/Button";
import { useSelector } from "react-redux";

const AllDocuments = () => {
  const {
    loading,
    setLoading,
    searchText,
    documentData,
    view,
    setView,
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,

    handleDocumentDetailPage,
    handleDateChange,
    createDocumentHandler,
    documentModal,
    setDocumentModal,
    setSelectedDocument,
    selectedDocument,
    getDocumentList,

    documentType,
    storeType,
    documentTypeLoading,
    setStoreType,
    resetDocumentList
  } = useDocument();
  const {
    user,
    userLoading
  } = useSelector((state) => state.user);
  const [deleteModal, setDeleteModal] = useState(false);

  const handleEditDocument = (item) => {
    setDocumentModal(true);
  };
  const columns = [
    {
      title: "Store",
      dataIndex: "store",
      sorter: true,
      render: (text, record, index) => (
        <h2 className="table-avatar d-flex">
          {/* <a
            onClick={() => handleDocumentDetailPage(record.id, index)}
            className="avatar"
          >
            <Image src={record.company_user.profile_image} type="user" />
          </a> */}
          <a
            onClick={() => handleDocumentDetailPage(record.id, index)}
            className="profile-split d-flex flex-column"
          >
            {record.store?.code} 
            <span className="small text-muted">
              {record.store?.name}
            </span>
          </a>
        </h2>
      ),
    },
 
    {
      title: "Document Name",
      dataIndex: "name",
      sorter: true,
      
      render: (text, record) => (
        <div className="profile-split d-flex flex-column">
          <span className="table-avatar">{record.name}</span>
         
        </div>
      ),
    },

    // {
    //   title: "Document No",
    //   dataIndex: "document_number",
    //   render: (text, record) => (
    //     <span className="table-avatar">{record.document_number}</span>
    //   ),
    // },

    {
      title: "Type",
      dataIndex: "document_type__name",
      sorter: true,
      align:"center",
      render: (text, record) => (
        <div className="dropdown">
          <span className="badge badge-soft-info">
            {record.document_type?.name}
          </span>
        </div>
      ),
    },

    {
 title: "Attachments",
      dataIndex: "document_sub_type",
      // sorter: true,
      align:"center",
      render: (text, record) => (
        <div className="dropdown">
        <span className="small text-muted">
              {" "}
              <i class="fa-solid fa-paperclip" /> {record.attachments_count}{" "}
              Attachments{" "}
            </span>
        </div>
      ),
    },
    

    {
      title: "Issue Date",
      dataIndex: "issue_date",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {formatDateHandler2(record.issue_date)}
        </span>
      ),
    },

    {
      title: "Expiry Date",
      dataIndex: "expiry_date",
      sorter: true,
      render: (text, record) => (
        <span className="table-avatar">
          {formatDateHandler2(record.expiry_date)}
        </span>
      ),
    },
    {
      title: "Expires In",
      dataIndex: "expiry_notify_in_days",
      sorter: false,
      align:"center",
      render: (text, record) => (
        <span className="table-avatar">{(record.expiry_in_days && record.expiry_in_days > 0) ? `${record.expiry_in_days} day(s)` : "N/A"}</span>
      ),
    },
    {
      title: "Status",
      dataIndex: "is_expired",
      sorter: true,
      align:"center",
      render: (text, record) => (
        <div className="dropdown">
          <span
            className={`badge badge-soft-${
              record.is_expired ? "danger" : "success"
            }`}
          >
            {record.is_expired ? "Expired" : "Active"}
          </span>
        </div>
      ),
    },
    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   sorter: true,
    //   render: (text, record) => (
    //     <span className="table-avatar">
    //       {record.description}
    //     </span>
    //   )

    // },
    {
      title: "Action",
      render: (text, record) => (
        <div className="dropdown dropdown-action text-end">
          <Link
            to="#"
            className="action-icon dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="material-icons">more_vert</i>
          </Link>
          <div className="dropdown-menu dropdown-menu-right">
            {/* <Link
            onClick={()=>{
              handleEditDocument(recort)
              setDocumentModal(true)
              // setSelectedDocument(record)

            }}
              // to="#"
              className="dropdown-item"
              // data-bs-toggle="modal"
              // data-bs-target="#edit_job"
            >
              <i className="fa fa-pencil m-r-5" /> Edit
            </Link> */}
            {
              (user?.role?.access_scope == "all" || user?.id == record?.company_user?.id )&&
            <Link
              onClick={() => {
                setDeleteModal(true);
                setSelectedDocument(record);
              }}
              to="#"
              className="dropdown-item"
              // data-bs-toggle="modal"
              // data-bs-target="#delete"
            >
              <i className="fa fa-trash m-r-5" /> Delete
            </Link>
            }
          </div>
        </div>
      ),
    },
  ];

  useEffect(()=>{
    resetDocumentList()
    setStoreType("store")
    
  },[])

  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
        {
          documentData.length == 0 &&
          <div className="row">
            <div className="col-12">
              <h4 className="user-name m-t-10 mb-0 text-ellipsis text-start">
                <a>No documents found</a>
              </h4>
            </div>
          </div>
        }
          {documentData.map((document, index) => (
            <div
            // onClick={() => handleDocumentDetailPage(document.id, index)}
            className="col-md-6 col-sm-12 col-lg-6 col-xl-4 col-xxl-3"
            key={document.id}
            >
              <div className="profile-widget">
                <div className="dropdown profile-action">
                  <Link
                    
                    //   to="#"
                    className="action-icon dropdown-toggle"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i className="material-icons">more_vert</i>
                  </Link>

                  <div className="dropdown-menu dropdown-menu-right">
                    {/* <Link
                      className="dropdown-item"
                      onClick={() => handleDocumentDetailPage(record.id, index)}
                      // to="#"
                      //  data-bs-toggle="modal"
                      //  data-bs-target="#edit_resume"
                    >
                      <i className="fa fa-pencil m-r-5" /> Edit
                    </Link> */}
                    {
                      (user?.role?.access_scope == "all" || user?.id == document?.company_user?.id )&&
                    <Link
                      className="dropdown-item"
                      onClick={() => {
                        setDeleteModal(true);
                        setSelectedDocument(document);
                      }}
                      // to="#"
                      //data-bs-toggle="modal"
                      // data-bs-target="#delete"
                    >
                      <i className="fa-regular fa-trash-can m-r-5" /> Delete
                    </Link>
                    }
                  </div>
                </div>
                <div className="row">
                  <div className="col-12">
                    <h4 className="user-name m-t-10 mb-0 text-ellipsis text-start">
                      <a
                        onClick={() =>
                          handleDocumentDetailPage(document.id, index)
                        }
                      >
                        {document?.store?.code} 
                        {/* {"  "}{" "}
                        {document?.company_user.last_name} */}
                      </a>
                    </h4>

                    <div className="m-t-10 small text-muted text-start">
                      {document?.store?.name}
                    </div>
                    {/* <div className="small text-muted text-start">
                      {document?.company_user.position_name}
                    </div> */}

                    <div className="small text-muted text-start">
                      {document.name}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      );
    }
  };

  const deleteHandler = (props) => {
    console.log(selectedDocument, "LLLLLLLL");
    deleteDocumentApi(selectedDocument?.id)
      .then((res) => {
        toast.success("Document deleted successfully!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
        getDocumentList();
        setDeleteModal(false);
      })
      .catch((e) => {
        toast.error("Error deleting document!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
      });
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle={toTitleCase(storeType) + " Documents"}
            title="Dashboard"
            subtitle="Store Documents"
            modal="#add_document"
            name="Add Document"
            view={view}
            setDocumentModal={setDocumentModal}
            setView={setView}
          />

          <DocumentListFilter
            filters={filters}
            handleInputChange={handleInputChange}
            searchPlaceholder={"Search Documents"}
            handleFilterDrawer={handleFilterDrawer}
            handleFilterChange={handleFilterChange}
            loading={loading}
            storeType={storeType}
            setStoreType={setStoreType}
            documentType={documentType}
          />

          {view == "grid" ? (
            <div className="row">
              <GridView />
              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                  <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}
                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                        );
                      }
                      return null;
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="table-responsive">
                {/* <SearchBox pageSettings={pageSettings} setPageSettings={setPageSettings} /> */}
                <Table
                // scroll={{ x: "max-content", y: "max-content" }} // 👈 Keeps horizontal scrollbar
                  className="table-striped"
                  columns={columns}
                  dataSource={documentData}
                  rowKey={(record) => record.id}
                  loading={loading}
                  pagination={{
                    total: pageSettings?.total,
                    pageSize: pageSettings?.pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: pageSizeOptions,
                    // showQuickJumper: true,
                    itemRender: itemRender,
                    position: "right",
                    current: pageSettings?.page,
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`,
                  }}
                  onChange={handleChange}
                />
              </div>
            </div>
          )}

          <AllDocumentAddPopup
            documentType={documentType}
            documentTypeLoading={documentTypeLoading}
            getDocumentList={getDocumentList}
            setSelectedDocument={setSelectedDocument}
            setLoading={setLoading}
            selectedDocument={selectedDocument}
            loading={loading}
            createDocumentHandler={createDocumentHandler}
            documentModal={documentModal}
            setDocumentModal={setDocumentModal}
            storeType={storeType}
          />
          {/* Delete Modal */}
          <DeleteModal
            deleteModal={deleteModal}
            setDeleteModal={setDeleteModal}
            deleteHandler={deleteHandler}
            Name="Delete Record"
          />
        </div>
      </div>

      <DocumentsFilterDrawer
        searchPlaceholder={"Search Documents"}
        showFilterDrawer={showFilterDrawer}
        handleFilterDrawer={handleFilterDrawer}
        handleFilterChange={handleFilterChange}
        filters={filters}
        handleInputChange={handleInputChange}
        handleApplyFilter={handleApplyFilter}
        filterLoading={filterLoading}
        handleDateChange={handleDateChange}
        documentType={documentType}
        storeType={storeType}
      />
      {/* Delete Modal */}
    </>
  );
};

export default AllDocuments;
